import { isLoading, Loading } from "../../../Loading";
import { AppAgenciesState } from "../../../system/AppState/AppAgenciesState";

export default function useCaregiverMedflytAgencyStatus(props: {
  appAgenciesState: AppAgenciesState | Loading;
}) {
  const agencies = isLoading(props.appAgenciesState)
    ? []
    : props.appAgenciesState.agencies.values();

  let caregiverStatusInMedflyt = null;

  for (const agency of agencies) {
    if (agency.agency.isMedflytAgency) {
      caregiverStatusInMedflyt = agency.status;
      break;
    }
  }

  return { caregiverStatusInMedflyt };
}
